import { ArrowRight, ScanLine } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { pendingCombineClaimPath, readPendingCombineClaim } from '../../lib/pendingCombineClaim'

export default function PendingCombineClaimBanner() {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading || !user || location.pathname === '/combine/claim') return null

  const token = readPendingCombineClaim()
  const path = pendingCombineClaimPath(token)
  if (!path) return null

  return (
    <div className="border-hd-cyan/30 bg-hd-dark/95 fixed inset-x-3 bottom-3 z-[90] mx-auto max-w-xl rounded-2xl border p-3 shadow-2xl backdrop-blur-xl sm:bottom-5 sm:p-4">
      <div className="flex items-center gap-3">
        <div className="border-hd-cyan/25 bg-hd-cyan/10 text-hd-cyan flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border">
          <ScanLine className="h-5 w-5" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-hd-cyan text-[9px] font-black tracking-[0.16em] uppercase">
            ARGUS Combine
          </p>
          <p className="mt-0.5 text-sm font-black">
            You have a Combine entry waiting to be claimed.
          </p>
        </div>
        <Link
          to={path}
          className="hd-btn-primary inline-flex min-h-10 shrink-0 items-center gap-2 px-3 text-xs font-black"
        >
          Finish <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </div>
  )
}
